import React from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react'

class BurialSight extends React.Component {
   constructor(props){
        super(props);
        this.state = {
            cemetaryName: ''
        }

    }
    render(){
        return(
            <div>
                <Map className="BurialSight-map"
                    google={this.props.google}
                    zoom={10}
                    initialCenter={{
                     lat: 41.003549,
                     lng: -81.814563
                    }}>
                    <Marker />
                 </Map>
            </div>
        );
    }
}
export default GoogleApiWrapper({
 apiKey: ('AIzaSyAnC3imiVKUtUEtuPDoSVaF7C1aAHpT9gs')
})(BurialSight);